module.exports = __webpack_public_path__ + "img/madness_900.d319aca0.png";